<script>
    import { AppStore } from "$/stores/AppStore";
</script>

<svelte:head>
    <!-- Google Analytics (Dashboard) -->
    <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-Y10W8VS9N0"
    ></script>
    <script>
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            dataLayer.push(arguments);
        }
        gtag("js", new Date());

        gtag("config", "G-Y10W8VS9N0");
    </script>

    <!-- Intercom -->
    <script>
        // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/xzk7pqs8'
        (function () {
            var w = window;
            var ic = w.Intercom;
            if (typeof ic === "function") {
                ic("reattach_activator");
                ic("update", w.intercomSettings);
            } else {
                var d = document;
                var i = function () {
                    i.c(arguments);
                };
                i.q = [];
                i.c = function (args) {
                    i.q.push(args);
                };
                w.Intercom = i;
                var l = function () {
                    var s = d.createElement("script");
                    s.type = "text/javascript";
                    s.async = true;
                    s.src = "https://widget.intercom.io/widget/xzk7pqs8";
                    var x = d.getElementsByTagName("script")[0];
                    x.parentNode.insertBefore(s, x);
                };
                if (document.readyState === "complete") {
                    l();
                } else if (w.attachEvent) {
                    w.attachEvent("onload", l);
                } else {
                    w.addEventListener("load", l, false);
                }
            }
        })();
    </script>

    <!-- Clarity -->
    <script type="text/javascript">
        (function (c, l, a, r, i, t, y) {
            c[a] =
                c[a] ||
                function () {
                    (c[a].q = c[a].q || []).push(arguments);
                };
            t = l.createElement(r);
            t.async = 1;
            t.src = "https://www.clarity.ms/tag/" + i;
            y = l.getElementsByTagName(r)[0];
            y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", "jkqfi5ci8t");
    </script>

    <!-- LemonSqueezy -->
    <script
        src="https://app.lemonsqueezy.com/js/lemon.js"
        defer=""
        on:load={() => ($AppStore.lemonSqueezy.isLoaded = true)}
    ></script>

    <!-- Paddle -->
    <script
        src="https://cdn.paddle.com/paddle/v2/paddle.js"
        defer=""
        on:load={() => ($AppStore.paddle.isLoaded = true)}
    ></script>

    <!-- Google Tag Manager -->
    <script>
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", "GTM-WMQMWNNW");
    </script>
    <!-- End Google Tag Manager -->
</svelte:head>
